module.exports = __webpack_public_path__ + "img/verbatim.9137e351.png";